(function () {
	'use strict';

	a3_cabin_reports.controller('LoginCtrl', LoginCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name LoginCtrl
    * @description 
    *  Manages the login view
    * @ngInject
    */
	function LoginCtrl($location, $scope, localStorageMD5Service, UserFactory) {

		$scope.isSupported = isSupported;

		$scope.isSecure = UserFactory.isSecure();
		$scope.isLoggingIn = false;
		$scope.formData = {};
		$scope.goSecure = goSecure;
		$scope.errorName = "";
		$scope.goNormal = goNormal;
		$scope.moreInfo = false; // used to show more info on the page
		$scope.toggleMoreInfo = toggleMoreInfo;
		$scope.processForm = processForm;
		$scope.resetDevice = resetDevice;
		$scope.resetUser = resetUser;
		$scope.loginFailedAttemps = UserFactory.getLoginFailedAttemps();
        /**
         * Informs you if local storage is supported 
         * @memberof LoginCtrl
         * @returns {boolean} isSupported
         */
		function isSupported() {
			return localStorageMD5Service.isSupported;
		}

        /**
         * Converts application to normal local storage mode 
         * @memberof LoginCtrl
         */
		function goNormal() {
			var path = window.location.href;
			path = path.replace('?secure', '');
			window.location = path;
			location.reload();
		}

		  /**
         * Proccess login form and try to login
         * @memberof LoginCtrl
         */
		function goSecure() {
			var path = window.location.href;
			path = path + '?secure';
			window.location = path;
			location.reload();
		}

		/**
         * Show More info
         * @memberof LoginCtrl
         */
		function toggleMoreInfo() {
			$scope.moreInfo = !$scope.moreInfo;
		}

        /**
         * Proccess login form and try to login
         * @memberof LoginCtrl
         */
		function processForm() {
			$scope.loginFailedAttemps = UserFactory.getLoginFailedAttemps();
			if($scope.loginFailedAttemps > 3){
				localStorageMD5Service.remove('failedLoginAttemps');
				resetUser();
			}
			else{
				$scope.isLoggingIn = true;
				UserFactory.azlogin(afterLoginSuccess, afterLoginError, afterLoginFinal)
				.catch(error => {
					//console.error("An error occurred during login:", error);
					afterLoginError();
				});

			}
		}

        /**
         * AfterLoginSuccess
         * @memberof LoginCtrl
         */
        function afterLoginSuccess() {
            $scope.isLoggingIn = false;
            // load main page
            $scope.errorName = "";
            $location.path("/");
        }

        /**
         * afterLoginFinal
         * @memberof LoginCtrl
         */
		function afterLoginFinal() {
			$scope.isLoggingIn = false;
		}

		/**
         * AfterLoginError
         * @memberof LoginCtrl
         */
		function afterLoginError(response) {
			$scope.isLoggingIn = false;

			// display an error message
			if (response && response.status == 401) {
				if (response.data && response.data.Message)
					$scope.errorName = response.data.Message.length > 1 ? response.data.Message : "You are not authorized to use this CLS Cabin app";
				else
					$scope.errorName = "You are not authorized to use this CLS Cabin app";
			} else if (response && response.status == 404) {
				$scope.errorName = "Could not reach the remote server for authentication. Please connect to the Internet and try again.";
			} else {
				$scope.errorName = "An error occured during authentication. Please make sure you are connected to the Internet and try again.";
			};
		}


		/**
         * Redirect to reset view
         * @memberof LoginCtrl
         */
		function resetDevice() {
			$location.path("/reset");
		}
		/**
         * Sign out
         * @memberof LoginCtrl
         */
		function resetUser(){
			UserFactory.azSignOut();
		}

	}

})();